/*
 *  This file menu-codes.constant.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 2022
 *  (C) 2015-2022. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 *
 */

export const MENU_CODES = {
    DASHBOARD: {
        HOME: 'home_1',
        SETUP: 'setup_2'
    },
    SETUP: {
        USER: 'user_3',
        PAGE_ACCESS_RIGHTS: 'page_access_rights_4',
        ANNOUNCEMENT: 'announcement_5',
        EVENT: 'event_6',
        HR_NPS:'hrnps_9',
        EMPLOYEE_NPS:'employeenps_10',
        SERVICEDASHBOARD:'services_11',
        ADOPTION_REQUESTS:'Adoption_Request_13',
        CUSTOMER_OVERVIEW:'customer_overview_15',
        USAGE:'usage_report_17',
        TEAMPERFORMANCE:'team_performance_19',
        CUSTOMER:'customer_34',
        PENDING_CUSTOMER : 'pending_customer_35',
        LEAD_CUSTOMER : 'lead_97',
        FREE_CUSTOMER : 'free_customer_98',
        CUSTOMER_DISCOUNT:"customer_discount_37",
        USAGE_ALERT:"usage_alerts_42",
        BENEFIT_OFFER:"employeeoffer_65",
        INVOICE : 'invoice_66',
        CREDIT : 'credit_68',
        REPORT : 'report_72',
        SERVICES : 'Services_74',
        MARKET_PLACE:'hrmarketplace_78',
        RENEW_SUBSCRIPTION: 'renew_subscription_90',
        CUSTOMER_BILLING: 'customer_billing_124'
    }
};
